import { render } from "./App.vue?vue&type=template&id=1136b83e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1136b83e&lang=css"

import exportComponent from "/home/tobi/Documents/workspace/ytobi.github.io-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__